import { render, staticRenderFns } from "./Repositories.vue?vue&type=template&id=522d47aa&"
import script from "./Repositories.vue?vue&type=script&lang=ts&"
export * from "./Repositories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports